import { FieldValues, Path, UseFormSetError } from "react-hook-form";

import { validateError } from "./axiosErrorParser";

export const setFormErrors = <T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
) => {
  const validatedError = validateError(error);

  if (validatedError) {
    const fields = validatedError.response?.data?.error?.fields;

    if (fields && typeof fields === "object") {
      Object.entries(fields).forEach(([field, messages]) => {
        if (Array.isArray(messages) && messages.length > 0) {
          setError(field as Path<T>, {
            type: "manual",
            message: `${messages[0]}`,
          });
        }
      });
    }
  }
};
